<template>
    <div class="pop-quit" v-show="showQuitModal" v-cloak @click="closeQuitModal">
            <div class="pop-body" @click="preventDefault">
                <img :src="activityImgSrc" class="img" @click="toFreeGet">
                <!-- <img :src="btnImgSrc" class="btn-get" @click="toFreeGet"> -->
            </div>
        </div>
</template>

<script>
export default {
    name: 'QuitModal',
    props:['showQuitModal', 'activityImgSrc' , 'btnImgSrc', 'toUrl'],
    methods: {
        toFreeGet(){
            window.location.href=this.toUrl;
        },
        preventDefault(e) {
            e.stopPropagation()
        },
        closeQuitModal(){
            this.$emit("closeQuitModal");
        }
    }
}
</script>


<style scoped>
    .pop-quit {
        position: fixed;
        z-index: 99;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .pop-quit .pop-body {
        width: 100%;
        position: relative;
    }
    
    .pop-quit .img {
        width: 100%;
    }
    
    .pop-quit .btn-get {
        position: absolute;
        bottom: 130px;
        width: 60%;
        left: 20%;
        -webkit-animation: mymove .8s infinite;
    }

</style>



// WEBPACK FOOTER //
// QuitModal.vue?64b6af7c